import { shallowEqual, useSelector } from 'react-redux'


const selector = state=> state.studentGroupReducer

export const useStudentGroup = () =>{
    const selectedData = useSelector(selector, shallowEqual)
    return selectedData;
}